import {documentUtils} from 'front-onceforall-core';

import config from '../../../../config';

import authenticationService from '../../../services/authentication/AuthenticationService';
import documentService from '../../../services/document/DocumentService';
import {openOrSaveFile} from '../../../utils/http';
import {getDocumentsByCountry} from '../../../utils/document';
import {recordGAEvent} from '../../../utils/analytics';

export const PREVENT_SPECIAL_DOWNLOAD_TYPES = ['FOREIGN_EMPLOYEES'];

export const getDocumentPermissions = (isBackOffice, doc) => ({
  canEditAdditionalDesignation: false,
  canSeeSignAction: false,
  canSign: false,
  canUpload: false,
  canUploadByMandate: false,
  canDownload: true,
  canDownloadWithInvalidState: false,
  canDownloadProof: !PREVENT_SPECIAL_DOWNLOAD_TYPES.includes(doc?.type?.code),
  canDownloadExcel: !PREVENT_SPECIAL_DOWNLOAD_TYPES.includes(doc?.type?.code),
  canDuplicate: false,
  canDelete: false,
  isBackOffice,
  canSeePayrollRatio: true
});

const handleDocumentFileOpen = (document, excel) => {
  if (document.unpublished) {
    recordGAEvent('BUYER_DOCUMENT', "Download supplier's document");
  } else {
    recordGAEvent('BUYER_DOCUMENT', "Download current supplier's document");
  }
  authenticationService.authRedirect(documentService.getFileUrl(document.uid, excel))
    .then(authUrl => openOrSaveFile(authUrl));
};

const handleDocumentProofFileOpen = document => {
  authenticationService.authRedirect(documentService.getFileProofUrl(document.uid))
    .then(authUrl => openOrSaveFile(authUrl));
};

export const documentActions = {
  onDownload: document => handleDocumentFileOpen(document, false),
  onDownloadExcel: document => handleDocumentFileOpen(document, true),
  onDownloadProof: handleDocumentProofFileOpen,
  onOpen: document => {
    window.location.href = `${config.backOfficeUrl}/documents/${document.uid}`;
  }
};

export const getDossierName = dossier => {
  if (dossier === 'BUSINESS') {
    return 'dossier.labels.BUSINESS.ALL';
  }

  return `dossier.labels.${dossier}`;
};

export const getTimelineVersions = (organisationId, subcontractor) => documentVersions => (
  documentService.getAllDocumentValidVersionsBySubcontractor(
    organisationId,
    subcontractor.details.organisationId,
    documentVersions[0].correlationId
  )
);

export const getProcessedDocuments = (dossierCountry, rawDocuments) => {
  let documentVersions = getDocumentsByCountry(rawDocuments, dossierCountry).map(documentUtils.computeHasAnotherOccurrenceInSameDossier(rawDocuments));
  documentVersions = documentUtils.groupDocumentsByCorrelationId(documentVersions);
  documentVersions = documentUtils.removeArchivedCorrelationIds(documentVersions);
  return documentUtils.groupAndOrderDocumentVersionsByDossierType(documentVersions);
};
